












































import { Component, Prop, Vue } from 'vue-property-decorator';
import { ReferenceImage, ReferenceImageSize } from '@/models/references/reference-image';
import { mdbTooltip, mdbBtn, mdbIcon, mdbRow, mdbCol, mdbAlert } from '@folky-tools/mdbvue';

@Component({
    components: { mdbTooltip, mdbBtn, mdbIcon, mdbRow, mdbCol, mdbAlert }
})
export default class ReferenceImages extends Vue {
    @Prop({ type: Boolean, default: false }) private canEdit?: boolean;
    @Prop() private images!: ReferenceImage[];
    private maxImageAmount: number = 6;

    get smallImages(): ReferenceImage[] {
        return this.images ? this.images.filter(image => image.size === ReferenceImageSize.Small) : [];
    }

    private addNewImage(): void {
        this.$emit('addNewImage');
    }

    private deleteImage(id: number): void {
        this.$emit('deleteImage', id);
    }

    private changeImage(id: number): void {
        this.$emit('changeImage', id);
    }
}
